<template>
    <svg class="home-page__svg" width="250" height="450" viewBox="0 0 250 450" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="5" cy="5" r="4.5" fill="#00A4FF" stroke="#00A4FF"/>
        <path d="M5 5 h65 l28 28 v210 h-96 v135 h205" stroke="#00A4FF" stroke-width="2"/>
        <circle cx="205" cy="377" r="4.5" fill="#00A4FF" stroke="#00A4FF"/>
    </svg>
</template>
